import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { JsonService } from '@services/jsons/json.service';
import { ScreenService } from '@services/screens/screen.service';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';

@Component({
    selector: 'app-json-edit',
    templateUrl: './json-edit.component.html',
    styleUrls: ['./json-edit.component.scss'],
    providers: [JsonService, ScreenService, AngieScreensService],
    standalone: false
})
export class JsonEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[];
  title = 'Edit Custom JSON: ';
  isLoading = true;
  boundJson: Models.FakeJSON;
  screen: any;
  screenPath = 'screens';
  jsonId: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private jsonService: JsonService,
    private screenService: ScreenService,
    private angieScreensService: AngieScreensService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    if (this.activatedRoute.snapshot.params['id']) {
      this.jsonId = this.activatedRoute.snapshot.params['id'];
      this.jsonService.get(this.activatedRoute.snapshot.params['id']).then(result => {
        this.boundJson = result;
        this.fetchScreen(this.boundJson.screenUUID).then(() => {
          this.title += this.screen.name + ' ' + this.boundJson.language;
        });
        this.isLoading = false;
        this.loadForm();
      });
    } else if (this.activatedRoute.snapshot.params['uuid']) {
      this.fetchScreen(this.activatedRoute.snapshot.params['uuid']).then(() => {
        this.title = 'New CustomJSON for: ' + this.screen.name;
      });

      this.boundJson = <Models.FakeJSON>Models.ModelFactory.createModelInstanceByName('FakeJSON');
      this.boundJson.populateFromJSON({
        data: '{}',
        screenUUID: this.activatedRoute.snapshot.params['uuid']
      });
      this.isLoading = false;
      this.loadForm();
    }
  }

  fetchScreen(uuid) {
    return this.screenService.find(0, 1, { uuid: uuid }).then(screen => {
      if (!screen || !screen.data || !screen.data.length) {
        return this.angieScreensService.find(0, 1, { uuid: uuid }).then(angieScreen => {
          this.screenPath = 'angie-screens';
          this.screen = angieScreen.data && angieScreen.data.length ? angieScreen.data[0] : null;
        });
      }
      this.screen = screen.data[0];
    });
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);
    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundJson;
  }

  onSave() {
    return this.boundJson.validate(true).then(result => {
      if (this.validateJson()) {
        if (result.success) {
          if (this.jsonId) {
            this.jsonService.update(this.jsonId, this.boundJson).then(jsonResult => {
              this.snackbar.success('Saved JSON successfull');
            });
          } else {
            this.jsonService.create(this.boundJson).then(jsonResult => {
              this.snackbar.success('Saved JSON successfull');
            });
          }
        } else {
          this.snackbar.open('Could not create the json, please fill the form correctly');
        }
      }
    });
  }

  validateJson() {
    try {
      JSON.parse(this.boundJson.data);
    } catch (e) {
      this.snackbar.error('Invalid JSON ! ' + e, 5000,);
      return false;
    }
    return true;
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'info',
        title: 'Overview Screen',
        callback: () => {
          this.router.navigate([this.screenPath, this.screen._id]);
        }
      }),
      new PageAction({
        icon: 'settings',
        title: 'Screen Settings',
        callback: () => {
          this.router.navigate(['screen-settings', this.screen.uuid]);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Read Only',
        hidden: !this.activatedRoute.snapshot.params['id'],
        callback: () => {
          this.router.navigate(['jsons', this.jsonId, 'detail']);
        }
      }),
      new PageAction({
        icon: 'save',
        title: 'save',
        callback: () => {
          this.onSave();
        }
      })
    ];
  }
}
